// extracted by mini-css-extract-plugin
module.exports = {"page":"LoginPage_page__f0lmT","error":"LoginPage_error__3MHwO"};